import {useState} from "react";
import moment from "moment-timezone";

function useQueryState(
    parameter,
    serialize,
    deserialize,
    defaultValue = null,
) {
    let url = new URL(window.location.href);
    let oldValue = url.searchParams.get(parameter);

    let [stateValue, setStateValue] = useState(deserialize(url.searchParams.get(parameter)) ?? defaultValue);

    let setValue = (value) => {
        setStateValue(value);

        let url = new URL(window.location.href);

        if (value === null) {
            url.searchParams.delete(parameter);
        } else {
            url.searchParams.set(parameter, serialize(value));
        }

        history.replaceState(history.state, '', url.href);
    };

    return [stateValue, setValue];
}

export function useStringQueryState(key, defaultValue) {
    return useQueryState(
        key,
        (value) => value.toString(),
        (string) => string?.toString(),
        defaultValue
    );
}

export function useStringListQueryState(key, defaultValue = []) {
    return useQueryState(
        key,
        (value) => value.join('|'),
        (string) => {
            let value = string?.split('|') ?? defaultValue;

            if (value.length === 1 && value[0].trim() === '') {
                value = defaultValue;
            }

            return value;
        },
        defaultValue
    );
}

export function useDateQueryParameter(key, defaultValue) {
    return useQueryState(
        key,
        (value) => value.format('YYYY-MM-DD'),
        (string) => moment(string).isValid() ? moment(string) : null,
        defaultValue
    );
}